export const useTempSettings = (settings_temp, isGlobal) => {

  let { gvvi, page } = settings_temp ?? {}

  let _global;
  let _viewItems;
  let _views;

  if (isGlobal) {
    _global = gvvi?.global
    _viewItems = gvvi?.viewItems
    _views = gvvi?.views
  } else {
    _global = page
    _viewItems = page?.viewItems
  }

  return {
    _global: _.cloneDeep(_global),
    _viewItems: _.cloneDeep(_viewItems),
    _views: _.cloneDeep(_views)
  }
}